// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f6bfd71bb009a98e","6835":"cce68a9c8f87fec7"}[chunkId] + ".css";
};